import type { Client } from '~/types/graphql';

export const readableClients = (clients?: Client[]): string => {
  return clients?.map(client => client.company.name).join(', ') ?? '';
};
